var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsBoolean } from 'class-validator';
/**
 * What a patient may do with a given appointment right now (TM-9436 / #1334).
 * Computed server-side by the single `PatientActionPolicy` and attached to
 * each row of the patient appointment feed, so the frontend affordance and the
 * backend guard always agree — the button never offers something the server
 * would reject. `null` on the DTO everywhere outside the patient feed.
 */
export class PatientAppointmentActionsDto {
    /** Direct self-cancellation is allowed (participation active, above the cutoff, not past/in-progress). */
    canCancel;
    /** A reschedule request may be submitted (RS-005+). Non-binding preview here. */
    canRequestReschedule;
    /**
     * The cancellation falls inside the practice's grace window, so a qualitative
     * Ausfallhonorar warning + second confirm must be shown. Never a number — the
     * amount and payer gating are resolved downstream in the fee pipeline.
     */
    requiresGraceWarning;
    /**
     * A reschedule REQUEST would land inside the practice's grace window, so the
     * request form must carry the SAME qualitative Ausfallhonorar warning as a
     * cancellation (TM-9436 / #1339). Closes the "verschieben" dodge on the
     * patient side: rescheduling late is not silently cheaper than cancelling.
     * Like {@link requiresGraceWarning} it is never a number and carries no payer
     * resolution; unlike it, it ignores the 15-minute cancel cutoff because a
     * reschedule is a request, not a direct write.
     */
    requiresRescheduleGraceWarning;
    /**
     * Below the hard 15-minute cutoff before start (or already started/past): no
     * cancel is offered, the UI shows "Praxis kontaktieren" instead.
     */
    belowCutoff;
}
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], PatientAppointmentActionsDto.prototype, "canCancel", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], PatientAppointmentActionsDto.prototype, "canRequestReschedule", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], PatientAppointmentActionsDto.prototype, "requiresGraceWarning", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], PatientAppointmentActionsDto.prototype, "requiresRescheduleGraceWarning", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], PatientAppointmentActionsDto.prototype, "belowCutoff", void 0);
//# sourceMappingURL=patient-appointment-actions.dto.js.map